import { inject, computed } from 'vue'

const solutionCategoryIdsByDomain = {
  '人事・採用・労務領域': [1, 3, 4, 7, 15, 19, 20, 6, 27, 5],
  '財務・経理': [2, 8, 9, 10, 30, 31],
  '営業・マーケティング': [12, 13, 11],
  'その他': [14, 16, 17, 18, 21, 23, 24, 26, 28, 32, 33, 34, 35, 29],
}

export default function() {
  // constants
  const SOLUTION_CATEGORIES = inject<Record<string, string>>('SOLUTION_CATEGORIES')

  /**
   * フラットな key: value の組み合わせの定数型から Solution の領域ごとに区分されたオブジェクトへ変換
   */
  const solutionCategoriesByDomain = computed((): SolutionCategoriesByDomain => {
    const domain = {}
    let _category = {}

    for (const domainLabel in solutionCategoryIdsByDomain) {
      const _key = domainLabel as keyof typeof solutionCategoryIdsByDomain

      solutionCategoryIdsByDomain[_key].forEach(id => {
        const _id = id as keyof typeof SOLUTION_CATEGORIES

        Object.assign(_category, { [_id]: SOLUTION_CATEGORIES![_id] })
      })
      Object.assign(domain, { [domainLabel]: _category })

      _category = {}  // 初期化
    }

    return domain
  })

  /**
   * 指定のカテゴリー ID から対応するカテゴリーのラベルを取得
   * @param solutionId 対象のカテゴリー ID
   */
  const getSolutionCategoryLabel = (solutionId: number): string => {
    const label = SOLUTION_CATEGORIES![solutionId as keyof typeof SOLUTION_CATEGORIES]
    return label ? label : ''
  }


  return {
    // computed
    solutionCategoriesByDomain,

    // methods
    getSolutionCategoryLabel,
  }
}
